import { render } from "./AccountProfile.vue?vue&type=template&id=33219f5b"
import script from "./AccountProfile.vue?vue&type=script&lang=js"
export * from "./AccountProfile.vue?vue&type=script&lang=js"

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__